// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1MpKM","boxTitle":"Qualiphy_boxTitle__CtSQB","box":"Qualiphy_box__1YamX","toggleWrap":"Qualiphy_toggleWrap__3Iybj"};